import React, { useMemo } from "react";
import { useOrdersListUIContext } from "./OrdersListUIContext";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { OrdersListTable } from "./orders-list-table/OrdersListTable";
import { OrderListFilter } from "./order-list-filter/OrderListFilter";

export function OrdersListCard() {
  const ordersListUIContext = useOrdersListUIContext();
  const ordersListUIProps = useMemo(() => {
    return {
      ids: ordersListUIContext.ids,
      queryParams: ordersListUIContext.queryParams,
      setQueryParams: ordersListUIContext.setQueryParams,
      openViewOrderPage: ordersListUIContext.openViewOrderPage,
    };
  }, [ordersListUIContext]);

  return (
    <Card>
      <CardHeader title={"آخرین سفارشات مواد اولیه"} />
      <CardBody>
        <OrderListFilter />
        <OrdersListTable />
      </CardBody>
    </Card>
  );
}
